import { Pipe, PipeTransform } from '@angular/core';
import diacritics from './normalizeString.diacritics';

@Pipe({
  name: 'normalizeString'
})
export class NormalizeStringPipe implements PipeTransform {
  private diacriticsMap: any = {};

  constructor() {
    for (let i = 0; i < diacritics.length; i++) {
      const letters = diacritics[i].letters;
      for (let j = 0; j < letters.length; j++) {
        this.diacriticsMap[letters[j]] = diacritics[i].base;
      }
    }
  }

  transform(input: string): string {
    if (input) {
      return input.replace(/[^\u0000-\u007E]/g, a => {
        return this.diacriticsMap[a] || a;
      });
    }
    return input;
  }
}
